import mitt from 'mitt'

import { defineNuxtPlugin } from '#imports'

// event emitter / pubsub bus

export default defineNuxtPlugin({
  parallel: true,
  setup (nuxtApp) {
    // console.log('[SERVER] 01.bus.js')

    const emitter = mitt()
    nuxtApp.bus = {
      on: (...args) => emitter.on(...args),
      off: (...args) => emitter.off(...args),
      emit: (...args) => emitter.emit(...args)
    }
  }
})
